/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Out_Material_Qty_ModeInputs */

const vi_stock_out_material_qty_mode = /** @type {(inputs: Stock_Out_Material_Qty_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trừ theo số lượng (không chọn lô)`)
};

/**

* @param {Stock_Out_Material_Qty_ModeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_material_qty_mode = /** @type {((inputs?: Stock_Out_Material_Qty_ModeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Material_Qty_ModeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_material_qty_mode(inputs)
});